import { render, staticRenderFns } from "./TaxReceipt.vue?vue&type=template&id=4c5ac58f&scoped=true"
import script from "./TaxReceipt.vue?vue&type=script&lang=js"
export * from "./TaxReceipt.vue?vue&type=script&lang=js"
import style0 from "./TaxReceipt.vue?vue&type=style&index=0&id=4c5ac58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ac58f",
  null
  
)

export default component.exports